<script lang="ts">
	/**
	 * Introduction / instruction screen shown before the test begins.
	 * Displays the rules and a "Start Test" button.
	 */

	/** Called when the user clicks "Start Test". */
	let { onStart }: { onStart: () => void } = $props();
</script>

<div class="mx-auto flex max-w-xl flex-col items-center gap-6 py-16">
	<h1 class="text-4xl font-bold">듀얼 1-백 테스트</h1>

	<p class="text-lg leading-relaxed text-gray-300">
		화면에 도형이 나타나고 동시에 소리가 들립니다.
	</p>

	<div class="w-full space-y-4 rounded-lg border border-gray-600 bg-gray-800 p-6 text-left">
		<h2 class="text-xl font-semibold">진행 방법</h2>
		<ul class="list-inside list-disc space-y-2 text-gray-300">
			<li>
				<strong>도형</strong>이 <em>이전</em> 도형과 같으면
				<kbd class="rounded border border-gray-500 bg-gray-700 px-2 py-0.5 font-mono text-sm">
					A
				</kbd>
				키를 누르세요
			</li>
			<li>
				<strong>소리</strong>가 <em>이전</em> 소리와 같으면
				<kbd class="rounded border border-gray-500 bg-gray-700 px-2 py-0.5 font-mono text-sm">
					L
				</kbd>
				키를 누르세요
			</li>
			<li>둘 다 같으면 <strong>두 키</strong>를 모두 누르세요.</li>
			<li>최대한 빠르고 정확하게 응답하세요.</li>
		</ul>
		<p class="mt-4 text-sm text-gray-400">
			테스트는 약 15초 동안 진행됩니다 (시행 5회 + 워밍업).
		</p>
	</div>

	<button
		onclick={onStart}
		class="cursor-pointer rounded-lg bg-blue-600 px-8 py-3 text-lg font-semibold text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
	>
		테스트 시작
	</button>
</div>
